// extracted by mini-css-extract-plugin
export default {"AuctionSpaceButton":"Auction_AuctionSpaceButton__Um8Ej"};